module.exports = __webpack_public_path__ + "img/offer-2023-04-mobile.a3fd5c1e.png";